import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const VotingRemoveModal: React.FC<{
  show: boolean;
  category?: boolean;
  itemType?: 'player' | 'team';
  title?: string;
  message?: string;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ show, category = false, itemType = 'player', title, message, confirmLabel, onCancel, onConfirm }) => (
  <Modal show={show} onHide={onCancel} centered contentClassName="rounded-4" aria-labelledby="voting-remove-title">
    <Modal.Body style={{ padding: 28 }} className="text-center">
      <h5 id="voting-remove-title" className="fw-bold mb-2" style={{ fontSize: 20, color: '#000' }}>{title ?? (category ? 'Delete Category?' : `Remove ${itemType === 'team' ? 'Team' : 'Player'}?`)}</h5>
      <p style={{ fontSize: 14, color: '#666' }}>{message ?? `Are you sure you want to ${category ? 'delete this category' : `remove this ${itemType}`}?`}</p>
      <div className="d-flex gap-3 mt-3">
        <Button variant="outline-primary" className="w-100" style={{ borderRadius: 10, fontSize: 13 }} onClick={onCancel}>Cancel</Button>
        <Button variant="danger" className="w-100" style={{ borderRadius: 10, fontSize: 13, backgroundColor: '#ff5768', borderColor: '#ff5768' }} onClick={onConfirm}>{confirmLabel ?? (category ? 'Yes, Delete' : 'Yes, Remove')}</Button>
      </div>
    </Modal.Body>
  </Modal>
);

export default VotingRemoveModal;
